import { Collapse } from '@common-web';
import { Alert } from '@common-web/index';
import { Checkbox, Flex, Image } from 'antd';
import cx from 'clsx';
import React from 'react';
import placeholderImage from '../../../../../../assets/placeholder.png';
import productStyles from '../../../../products/manage-products/products-column.module.scss';
import LineItemCard from '../../line-items-modal/line-items-modal-body/line-item-card';

const BulkActionModal = ({
  selectedOrders = [],
  message = '',
  selectedLineItems = [],
  setSelectedLineItems = () => {},
}) => {
  const collapseItems = selectedOrders?.map((order) => {
    const nonIncludedOrderItemsString = order?.line_items
      ?.filter((item) => !selectedLineItems?.includes(item?.id))
      ?.map((item) => item?.name)
      ?.join(', ');
    return {
      key: order?.id,
      label: `ID ${order?.id} (${order?.line_items?.length} items)`,
      children: (
        <Flex vertical gap={'10px'}>
          <Flex vertical gap={'10px'}>
            {order?.line_items?.map((item) => (
              <Flex key={item?.id} align="center" gap={8}>
                {order?.line_items?.length > 1 && (
                  <Checkbox
                    checked={selectedLineItems?.includes(item?.id)}
                    onClick={() => {
                      const orderItems = order?.line_items?.map((orderItem) => orderItem?.id);
                      const selectedFromOrder = selectedLineItems?.filter((selected) => orderItems?.includes(selected));
                      const newSelectedItems = selectedLineItems?.includes(item?.id)
                        ? selectedFromOrder?.length > 1
                          ? selectedLineItems?.filter((selected) => selected !== item?.id)
                          : [...selectedLineItems]
                        : [...selectedLineItems, item?.id];
                      setSelectedLineItems(newSelectedItems);
                    }}
                  />
                )}
                <LineItemCard product={item} />
              </Flex>
            ))}
          </Flex>
          {nonIncludedOrderItemsString && (
            <Alert
              message={
                <span>
                  <span className="fw-600">{nonIncludedOrderItemsString}</span> will be split into a new order
                </span>
              }
              type={'warning'}
              showIcon
            />
          )}
        </Flex>
      ),
    };
  });

  return (
    <>
      <p>{message}</p>
      <Collapse items={collapseItems} />
    </>
  );
};

export default BulkActionModal;
